import { render, staticRenderFns } from "./TransactionCategoryDetail.vue?vue&type=template&id=f712395a"
import script from "@/controllers/transaction_category/transaction-category-detail.js?vue&type=script&lang=js&external"
export * from "@/controllers/transaction_category/transaction-category-detail.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCategoryDetail.vue?vue&type=style&index=0&id=f712395a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports